import { createReducer, on } from "@ngrx/store";
import * as Actions from "./actions";
import { RevisionStateInterface } from "src/app/revisions/models/revisionStateInterface";

export const initialState: RevisionStateInterface = {
    isLoading: false,
    revisions: [],
    error: null,
};

export const revisionsReducers = createReducer(
    initialState, 

    // Get Revisions
    on(Actions.getRevisions, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.getRevisionsSuccess, (state, action) => ({
        ...state,
        isLoading: false,
        revisions: action.revisions.slice().sort((a, b) => {
            const dateA = new Date(a.scheduledDate);
            const dateB = new Date(b.scheduledDate);
    
            // Handle invalid dates
            if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
                return 0; // Treat invalid dates as equal or handle accordingly
            }
    
            return dateA.getTime() - dateB.getTime(); // Sort ascending
        }),
    })),
    
    on(Actions.getRevisionsFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // Create Revision
    on(Actions.createRevision, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.createRevisionSuccess, (state, action) => ({
        ...state, 
        isLoading: false,
        revisions: [...state.revisions, action.revision].sort((a, b) => a.orderNumber.localeCompare(b.orderNumber))
    })),
    on(Actions.createRevisionFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // Update Revision
    on(Actions.updateRevision, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.updateRevisionSuccess, (state, action) => {
        const updatedRevisionIndex = state.revisions.findIndex(revision => revision.id === action.revision.id);
        
        if (updatedRevisionIndex === -1) {
            return state;
        }

        const updatedRevisions = [...state.revisions];
        updatedRevisions[updatedRevisionIndex] = action.revision;

        return {
            ...state,
            isLoading: false,
            revisions: updatedRevisions.sort((a, b) => a.orderNumber.localeCompare(b.orderNumber))
        };
    }),
    on(Actions.updateRevisionFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // Delete Revision
    on(Actions.deleteRevision, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.deleteRevisionSuccess, (state,action) => ({
        ...state, 
        isLoading: false,
        revisions: state.revisions.filter(revision => revision.id !== action.id)
      })),
    on(Actions.deleteRevisionFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // Complete Revision
    on(Actions.completeRevision, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.completeRevisionSuccess, (state, action) => {
        const updatedRevisionIndex = state.revisions.findIndex(revision => revision.id === action.revision.id);
        
        if (updatedRevisionIndex === -1) {
            return state;
        }

        const updatedRevisions = [...state.revisions];
        updatedRevisions[updatedRevisionIndex] = action.revision;

        return {
            ...state,
            isLoading: false,
            revisions: updatedRevisions.sort((a, b) => a.orderNumber.localeCompare(b.orderNumber))
        };
    }),
    on(Actions.completeRevisionFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),
);